import type { Quake } from '../api/types';

export type TimeWindow = '5m' | '15m' | '1h';
export type CategoryFilter = 'all' | 'politics' | 'crypto' | 'macro' | 'sports' | 'geopolitics' | 'earnings';
export type SignalMode = 'confirmed' | 'watchlist';

export interface DashboardFilters {
  window: TimeWindow;
  mode: SignalMode;
  category: CategoryFilter;
  query: string;
}

export const timeWindows: readonly TimeWindow[] = ['5m', '15m', '1h'];
export const categoryFilters: readonly CategoryFilter[] = [
  'all',
  'politics',
  'crypto',
  'macro',
  'sports',
  'geopolitics',
  'earnings',
];

export function filterMovers(items: readonly Quake[], filters: DashboardFilters) {
  const query = filters.query.trim().toLowerCase();
  return items.filter((item) => {
    const itemCategory = item.category.toLowerCase();
    const categoryOK = filters.category === 'all' || itemCategory === filters.category;
    const queryOK = query.length === 0 || item.question.toLowerCase().includes(query);
    return categoryOK && queryOK;
  });
}
